import ticketDetails from '../localization-messages/ticketDetails/es-US.json';
import ticketCancelForm from '../localization-messages/ticketCancelForm/es-US.json';
import ticketListing from '../localization-messages/ticketListing/es-US.json';
import ticketForm from '../localization-messages/ticketForm/es-US.json';
import headerFooter from '../localization-messages/headerFooter/es-US.json';
import reconfirmUserDetailsModal from '../localization-messages/reconfirmUserDetailsModal/es-US.json';
import termsModal from '../localization-messages/termsModal/es-US.json';

export const esUSTranslations = {
  ticketDetails,
  ticketCancelForm,
  ticketListing,
  ticketForm,
  headerFooter,
  reconfirmUserDetailsModal,
  termsModal,
};
